import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import Icon from "../../icon/index.vue";
import { useWindowResize } from "../hooks/useWindowResize";
import { IMenuItem } from "../types";

// 默认头像

export default /*#__PURE__*/_defineComponent({
  __name: 'common-header',
  props: {
    menus: null,
    activeRouteName: null,
    bannerImg: null,
    userName: null,
    userAvatar: null,
    hideMsgBtn: { type: Boolean },
    hasUnReadMsg: { type: Boolean }
  },
  emits: ["clickMenu", "logout", "showMsgeDrawer"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: "clickMenu", menu: IMenuItem): void;
  (event: "logout"): void;
  (event: "showMsgeDrawer"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  menus: IMenuItem[];
  activeRouteName: string;
  // 顶部图
  bannerImg?: string;
  // 用户名
  userName?: string;
  // 头像
  userAvatar?: string;
  // 是否隐藏消息按钮
  hideMsgBtn?: boolean;
  // 有未读消息
  hasUnReadMsg?: boolean;
}

const defaultAvatar = require("../../../../assets/imgs/default-avatar.png");
// 默认顶部图
const BannerDefaultImg = require("../assets/imgs/banner.png");





// 菜单壳
const menuWrapperRef = ref<HTMLDivElement>();
const menuWrapperMoveRef = ref<HTMLDivElement>();
const { wrapperSize, moveWrapperSize, shouldArrowVisible } = useWindowResize(
  menuWrapperRef,
  menuWrapperMoveRef
);
// 移动菜单距离
const menuMoveNum = ref<number>(0);

// 当前激活的菜单
const computedActiveFirstMenuIndex = computed<number>(() => {
  let activeFirstIndex = -1;
  for (let i = 0; i < props.menus.length; i++) {
    const fItem = props.menus[i];
    if (fItem.name && fItem.name === props.activeRouteName) {
      activeFirstIndex = i;
    } else if (
      fItem.children &&
      fItem.children.find((cItem) => cItem.name === props.activeRouteName)
    ) {
      activeFirstIndex = i;
    }
  }
  return activeFirstIndex;
});

// 菜单动态样式，用于滚动
const computedMenuItemsMoveWrapperStyle = computed(() => {
  return {
    width: `${props.menus.length * 152 + (shouldArrowVisible ? 28 : 0)}px`,
    "margin-left": `-${menuMoveNum.value}px`,
  };
});

// 移动step
const moveNumStepNum = 150;

// 左移
function onMenuMoveLeft() {
  let newNum = menuMoveNum.value - moveNumStepNum;
  if (newNum < 0) {
    newNum = 0;
  }
  menuMoveNum.value = newNum;
}

// 右移
function onMenuMoveRight() {
  const maxMoveNum = moveWrapperSize.value - wrapperSize.value + 30;
  let newNum = menuMoveNum.value + moveNumStepNum;
  if (newNum > maxMoveNum) {
    newNum = maxMoveNum;
  }
  menuMoveNum.value = newNum;
}

// 点击菜单
function onClickMenu(menu: IMenuItem) {
  if (!menu.children || menu.children.length === 0) {
    emits("clickMenu", menu);
  }
}

// 点击登出
function onLogout() {
  emits("logout");
}

// 显示消息列表抽屉
function showMessageListDrawer() {
  emits("showMsgeDrawer");
}

return { __sfc: true,defaultAvatar, BannerDefaultImg, emits, props, menuWrapperRef, menuWrapperMoveRef, wrapperSize, moveWrapperSize, shouldArrowVisible, menuMoveNum, computedActiveFirstMenuIndex, computedMenuItemsMoveWrapperStyle, moveNumStepNum, onMenuMoveLeft, onMenuMoveRight, onClickMenu, onLogout, showMessageListDrawer, Icon }
}

})